import { render } from "./BovineImportTable.vue?vue&type=template&id=75ac60f2&scoped=true"
import script from "./BovineImportTable.vue?vue&type=script&lang=js"
export * from "./BovineImportTable.vue?vue&type=script&lang=js"

import "./BovineImportTable.vue?vue&type=style&index=0&id=75ac60f2&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ac60f2"]])

export default __exports__